// removed by extract-text-webpack-plugin
module.exports = {"userMenuCompact":"_2XD8ocqYWjhB5-yv","content":"_1efArY7BALOcJUXO","logout":"_3stOa_WNhYPFYwr6","userContent":"rsAhWYu73YDXst1l","iconContainer":"_3Wqxd3CZv_RbWK1-","name":"_3VtoH1y1Yqa3KVG3","myPageLink":"_2aX8RivBqUv_KmdR","enter":"_9HSRRpqdfJiRNe1t","enterActive":"_1Cb4XA-XG6hPMISL","containerAnim":"_2x-RYqIx4GIbcX2C","userNameAnim":"_2hjJuei7tuAnY-V9","leave":"_135w9dsL6_zYvqiH","leaveActive":"_2BGFprs6pYgGFI2t","containerOutAnim":"_147vxd_7F0jfE3lD"};


//////////////////
// WEBPACK FOOTER
// ./app/components/User/UserMenu/UserMenuCompact.pcss
// module id = 511
// module chunks = 1